import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ServiceRelationsTableCtrl implements IController {
  service: any;

  private relationList: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.relationList = [];

    let relationList = [];
    _.forEach(this.service.taskList, (t) => {
      relationList = relationList.concat(t.relations || [])
    });
    this.relationList = relationList;

  }

  $onChanges(changes) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceRelationsTable', {
    bindings: {
      service: '<'
    },
    template: require('./service-relations-table.html').default,
    controller: ServiceRelationsTableCtrl
  });
